(function () {
  var STYLE_ID = 'shop-login-button-full-width';
  var STYLE_CSS = [
    ':host { display: block !important; width: 100% !important; max-width: 100% !important; }',
    'button {',
    '  width: 100% !important;',
    '  max-width: 100% !important;',
    '  height: 65px !important;',
    '  min-height: 65px !important;',
    '  margin-left: 0 !important;',
    '  margin-right: 0 !important;',
    '  border-radius: 0 !important;',
    '}',
    'button > span {',
    '  font-size: 14pt !important;',
    '  font-weight: 400 !important;',
    '  letter-spacing: 0.02em !important;',
    '  line-height: 1 !important;',
    '  height: 100% !important;',
    '  width: 100% !important;',
    '  box-sizing: border-box !important;',
    '}',
  ].join('');

  function ensureHostStyles(el) {
    el.style.setProperty('display', 'block', 'important');
    el.style.setProperty('width', '100%', 'important');
    el.style.setProperty('max-width', '100%', 'important');
  }

  function ensureInnerStyles(root) {
    var btn = root.querySelector('button');
    if (!btn) return;

    btn.style.setProperty('width', '100%', 'important');
    btn.style.setProperty('max-width', '100%', 'important');
    btn.style.setProperty('height', '65px', 'important');
    btn.style.setProperty('min-height', '65px', 'important');
    btn.style.setProperty('margin-left', '0', 'important');
    btn.style.setProperty('margin-right', '0', 'important');

    var span = btn.querySelector('span');
    if (span) {
      span.style.setProperty('font-size', '14pt', 'important');
      span.style.setProperty('width', '100%', 'important');
      span.style.setProperty('height', '100%', 'important');
    }
  }

  function injectStyle(root) {
    var existing = root.getElementById(STYLE_ID);
    if (existing) {
      if (existing.textContent !== STYLE_CSS) existing.textContent = STYLE_CSS;
      return;
    }

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = STYLE_CSS;
    root.appendChild(style);
  }

  function applyFullWidth(el) {
    if (!el || el.nodeName !== 'SHOP-LOGIN-BUTTON') return;

    ensureHostStyles(el);

    var inject = function () {
      var root = el.shadowRoot;
      if (!root) return false;

      injectStyle(root);
      ensureInnerStyles(root);
      return true;
    };

    inject();

    // Keep re-applying: Shopify re-renders the shadow button after load/login state.
    if (el.dataset.fullWidthWatching === 'true') return;
    el.dataset.fullWidthWatching = 'true';

    var shadowObserver = null;

    var watchShadow = function () {
      var root = el.shadowRoot;
      if (!root) return;

      if (shadowObserver) shadowObserver.disconnect();
      shadowObserver = new MutationObserver(function () {
        inject();
      });
      shadowObserver.observe(root, { childList: true, subtree: true, attributes: true });
      inject();
    };

    var hostObserver = new MutationObserver(function () {
      inject();
      watchShadow();
    });
    hostObserver.observe(el, { childList: true, subtree: true, attributes: true });

    watchShadow();

    // Retry briefly while the app finishes mounting
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      inject();
      watchShadow();
      if (tries >= 20 || (el.shadowRoot && el.shadowRoot.querySelector('button'))) {
        clearInterval(timer);
      }
    }, 250);
  }

  function init() {
    document.querySelectorAll('shop-login-button').forEach(applyFullWidth);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also catch late app-block inserts / section re-renders
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeName === 'SHOP-LOGIN-BUTTON') {
          applyFullWidth(node);
          return;
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('shop-login-button').forEach(applyFullWidth);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
